import { WebsocketContext } from "App";
import MessageService from "app/services/messageService";
import ProductService from "app/services/productService";
import MessagesList from "components/Message/MessagesList";
import ProductCard from "components/ProductCard";
import Dash from "containers/dash";
import { Product } from "data/data";
import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

export interface Messgae {
  id: number;
  created: string;
  username: string;
  message: string;
  type: string;
}

interface Params {
  username: string;
}

const MessageItem = ({ id, message, username, type }: Messgae) => {
  const [posstion, setPostion] = useState<string>("end");
  const params: Params | any = useParams();
  const [product, setProduct] = useState<Product>();

  const messageProduct = {
    productId: 1,
    message: "Ce produit est-il toujours disponible ?",
  };

  const pic = (
    <img
      src={process.env.REACT_APP_API_URL + "/api/media/avatar/" + username}
      className="object-cover h-10 w-10 rounded-full"
      alt=""
    />
  );
  useEffect(() => {
    if (params.username == username) {
      setPostion("start");
    }

    if (type == "item") {
      getProduct(message);

      // <ProductCard key={stay.id} data={stay} />
    }
  }, []);

  const getProduct = (productId: any) => {
    ProductService.getProduitById(productId).then((data) => {
      setProduct(data);
    });
  };

  //   const handleEnter = (event:any) => {
  //     if (event.keyCode === 13) {
  //       const message = document.getElementById("message-input")
  //       console.log(message)
  //     }
  //  };
  //  window.addEventListener('keydown', handleEnter);

  return (
    <div
      className={`${
        posstion == "start"
          ? "col-start-1 col-end-8"
          : "col-start-6 col-end-13  "
      } p-3 rounded-lg`}
    >
      <div
        className={`flex items-center  ${
          posstion == "start" ? "flex-row" : "justify-start flex-row-reverse"
        }`}
      >
        <div className="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0">
          {pic}
        </div>

        <div
          className={`relative text-sm  ${
            posstion == "start" ? "ml-3  bg-indigo-100" : "mr-3 bg-white"
          } py-2 px-4 shadow rounded-xl`}
        >
          {product ? (
            <div>
              <ProductCard mode="message" data={product} />
            </div>
          ) : null}
          <div>
            {product ? "Ce produit est-il toujours disponible ?" : message}
          </div>
        </div>
      </div>

      {/* <div className="col-start-6 col-end-13 p-3 rounded-lg"> */}
      {/* <div className="flex items-center justify-start flex-row-reverse">
                    <div
                      className="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0"
                    >
                      A
                    </div>
                    <div
                      className="relative mr-3 text-sm bg-indigo-100 py-2 px-4 shadow rounded-xl"
                    >
                      <div>I'm ok what about you?</div>
                    </div>
                  </div> */}
    </div>
  );
};
const Messages = () => {
  const params: Params | any = useParams();

  const [messages, setMessages] = useState<Messgae[]>([]);
  const [messageVal, setMessageVal] = useState<string>("");
  const ret = useContext(WebsocketContext);

  const loginData = localStorage.getItem("loginData")
    ? JSON.parse(localStorage.getItem("loginData")!)
    : {
        authChecked: false,
        loggedIn: false,
        token: "",
        user: null,
      };

  const scroll = () => {
    setTimeout(() => {
      const MessagesBody = document.getElementById("messages-body");
      MessagesBody?.scrollTo(0, MessagesBody.scrollHeight);
      console.log("scroll");
    }, 500);
  };

  useEffect(() => {
    if (params.username)
      MessageService.getDiscussionMessages(params.username).then((data) => {
        setMessages(data);
      });
    scroll();
  }, [ret.value, params.username]);

  const sendMessageevent = () => {
    if (ret.ready) {
      ret.send(JSON.stringify({ user: params.username, message: messageVal }));

      const newM: Messgae = {
        id: 0,
        created: "new Date()",
        username: loginData.user.username,
        message: messageVal,
        type: "string",
      };

      setMessages([...messages, newM]);
      setMessageVal("");
      scroll();
    }
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      sendMessageevent();
      // if(event.target.value != '' && params.username){
      //   sendMessage(JSON.stringify({user: params.username, message:event.target.value}))
      //   event.target.value = ''
      // }

      // MessageService.newMessage({
      //   "message": event.target.value,
      //   "received": params.username
      // }).then(data => {

      //   setMessages([... messages, data])
      //   event.target.value = ''
      // })
    }
  };

  return (
    <Dash>
      <div>
        <Helmet>
          <title>Messages</title>
        </Helmet>

        <div className="flex h-message antialiased text-gray-800">
          <div className="flex flex-row h-full w-full overflow-x-hidden">
            <div className="md:block hidden  flex flex-col py-8 pl-6 pr-2 w-80 bg-white flex-shrink-0  ">
              <MessagesList></MessagesList>
            </div>
            <div className="sm:block md:hidden min-w-2 h-full z-10 bg-white">
              <MessagesList></MessagesList>
            </div>
            <div className="flex flex-col flex-auto h-full py-2 md:p-6">
              <div className="flex flex-col flex-auto flex-shrink-0 rounded-2xl bg-gray-100 h-full p-4">
                <div
                  className="flex flex-col h-full overflow-x-auto mb-4"
                  id="messages-body"
                >
                  <div className="flex flex-col h-full">
                    <div className="grid grid-cols-12 gap-y-2">
                      {messages.map((m, i) => {
                        return (
                          <MessageItem
                            id={m.id}
                            created={m.created}
                            username={m.username}
                            message={m.message}
                            type={m.type}
                            key={i}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="flex flex-row items-center h-16 rounded-xl bg-white w-full px-4">
                  <div>
                    <button className="flex items-center justify-center text-gray-400 hover:text-gray-600">
                      {/* <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                  ></path>
                </svg> */}
                    </button>
                  </div>
                  <div className="flex-grow ml-4">
                    <div className="relative w-full">
                      <input
                        onChange={(e) => setMessageVal(e.target.value)}
                        value={messageVal}
                        onKeyDown={handleKeyDown}
                        type="text"
                        className="flex w-full border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 h-10"
                      />
                      <button className="absolute flex items-center justify-center h-full w-12 right-0 top-0 text-gray-400 hover:text-gray-600"></button>
                    </div>
                  </div>
                  <div className="ml-4">
                    <button
                      onClick={sendMessageevent}
                      className="flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 rounded-xl text-white px-1 py-2 flex-shrink-0"
                    >
                      <span className="ml-2">
                        <svg
                          className="w-4 h-4 transform rotate-45 -mt-px"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                          ></path>
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dash>
  );
};

export default Messages;
